import { render, staticRenderFns } from "./TPApplicationQuestionsTable.vue?vue&type=template&id=dba4798a&"
import script from "./TPApplicationQuestionsTable.vue?vue&type=script&lang=js&"
export * from "./TPApplicationQuestionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
